var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1735",
    "data-name": "Group 1735",
    transform: "translate(-434 -208)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_305",
    "data-name": "Ellipse 305",
    cx: 26,
    cy: 26,
    r: 26,
    transform: "translate(434 208)",
    fill: "#ed2024",
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19240",
    "data-name": "Path 19240",
    d: "M166,139.755V122.1a1.1,1.1,0,0,1,.611-.973,1.2,1.2,0,0,1,1.187.055l13.872,8.826a1.076,1.076,0,0,1,0,1.836L167.8,140.673A1.16,1.16,0,0,1,166,139.755Z",
    transform: "translate(287.727 103.071)",
    fill: "#f5f5f5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.6ff46366c9275a84695b94b3c5fc69da.svg";
export { ForwardRef as ReactComponent };